const IS_PRE_LAUNCH = false; // Since we decided to launch the institutional page before the pool, this controls ensuring UI matches this state

export const INSTITUTIONAL_CONSTANTS = {
	IS_PRE_LAUNCH,
	APOLLO_URL: 'https://www.apollo.com/',
	SECURITIZE_URL: 'https://securitize.io/',
	GAUNTLET_URL: 'https://www.gauntlet.xyz/',
	ACRED_SMALL_CARD_URL:
		'https://securitize.io/primary-market/apollo-diversified-credit-securitize-fund',
	SACRED_SMALL_CARD_URL: 'https://google.com', // TODO
	DRIFT_SMALL_CARD_URL: 'https://google.com', // TODO
	CONTENT_CARD_MAX_WIDTH: 1056,
	SACRED_MAIN_CTA_URL: '/earn/borrow-lend?pool=acred',
	MEDIUM_CARD_LINKS_ENABLED: false,
	CTA_BUTTONS_ENABLED: !IS_PRE_LAUNCH,
	CONTENT: {
		CTA_BUTTON_TEXT: (
			<>
				<span>
					Explore ACRED Isolated Pool
					<br />
					(COMING SOON)
				</span>
			</>
		),
		HEADER_TITLE: 'Discover RWA and onchain yield strategies',
		HEADER_SUBTITLE: `Bringing real-world assets onchain into Solana’s DeFi ecosystem`,
		FIRST_SECTION_TITLE: `First Pilot Partners`,
		FIRST_SECTION_SUBTITLE: `Drift is bringing Apollo’s Diversified Credit Fund (ACRED)—its flagship $1B private credit strategy—into DeFi on Solana for the first time. Apollo is a global alternative asset manager with over $750B in assets under management.`,
		FIRST_SECTION_APOLLO_CARD_DESCRIPTION: `Apollo Global Management is a leading alternative asset manager with $750 billion in assets under management.`,
		FIRST_SECTION_SECURITIZE_CARD_DESCRIPTION: `Securitize is a leading platform for tokenizing real-world assets, enabling compliant issuance and management of digital securities on-chain.`,
		FIRST_SECTION_GAUNTLET_CARD_DESCRIPTION: `Gauntlet develops risk-optimized DeFi vaults for institutional capital. For this pilot, Gauntlet designed a vault strategy that automates ACRED’s institutional looping.`,
	},
};
